import { gql } from '@apollo/client';
import { VARIANTS_PACK_FRAGMENT } from '@/contexts/items-context-queries';

export const RESTAURANT_VP_SUBSCRIPTION_FRAGMENT = gql`
  fragment RestaurantVP_Subscription on restaurant_variant_pack_subscriptions {
    config
    fulfillment_settings_uuid
    pause_from
    pause_until
    uuid
    variant_pack_uuid
  }
`;

export const GET_RESTAURANT_VP_SUBSCRIPTIONS = gql`
  query GetRestaurantVP_Subscriptions(
    $locale: String!
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $supplierUUID: uuid!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
  ) {
    getRestaurantVariantPackSubscriptions(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      next_delivery_date
      next_delivery_date_excluding_pauses
      restaurant_variant_pack_subscription {
        ...RestaurantVP_Subscription
        variant_pack {
          ...ItemsContext_VariantsPackFields
        }
      }
      restaurant_variant_pack_subscription_id
    }
  }

  ${RESTAURANT_VP_SUBSCRIPTION_FRAGMENT}
  ${VARIANTS_PACK_FRAGMENT}
`;

export const GET_NEXT_DELIVERY_DATE_FOR_SUBSCRIPTION = gql`
  query GetNextDeliveryDateFor_Subscription(
    $frequencyDays: Int!
    $fulfillmentSettingsUUID: uuid!
    $orderDay: DaysOfWeek!
    $restaurantUUID: uuid!
    $restaurantVPSubscriptionUUID: uuid
    $supplierUUID: uuid!
  ) {
    getNextDeliveryDateForSubscriptionSettings(
      frequency_days: $frequencyDays
      fulfillment_settings_id: $fulfillmentSettingsUUID
      restaurant_id: $restaurantUUID
      restaurant_variant_pack_subscription_id: $restaurantVPSubscriptionUUID
      supplier_id: $supplierUUID
      weekday: $orderDay
    ) {
      next_delivery_date
      next_placement_date
    }
  }
`;

export const UPSERT_RESTAURANT_SUBSCRIPTION_MUTATION = gql`
  mutation UpsertRestaurantVP_Subscription(
    $frequencyDays: Int!
    $fulfillmentSettingsUUID: uuid!
    $orderDay: DaysOfWeek!
    $quantity: Int!
    $restaurantUUID: uuid!
    $restaurantVPSubscriptionUUID: uuid
    $supplierUUID: uuid!
    $variantPackUUID: uuid!
  ) {
    upsertRestaurantVariantPackSubscription(
      frequency_days: $frequencyDays
      fulfillment_settings_id: $fulfillmentSettingsUUID
      quantity: $quantity
      restaurant_id: $restaurantUUID
      restaurant_variant_pack_subscription_id: $restaurantVPSubscriptionUUID
      supplier_id: $supplierUUID
      variant_pack_id: $variantPackUUID
      weekday: $orderDay
    ) {
      restaurant_variant_pack_subscription {
        ...RestaurantVP_Subscription
      }
    }
  }

  ${RESTAURANT_VP_SUBSCRIPTION_FRAGMENT}
`;
